import { defineComponent } from "@vue/composition-api";
import Badge from "@Shared/components/general/badge.vue";
export default defineComponent({
  name: "ClientProfileNameLabel",
  components: {
    Badge
  },
  props: {
    clientProfile: {
      type: [Object, String],
      required: true
    }
  }
});